export function ChevronUpIcon() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.54194 10.4595C3.2881 10.2057 3.2881 9.79412 3.54194 9.54028L7.54194 5.54028C7.79578 5.28644 8.20734 5.28644 8.46118 5.54028L12.4612 9.54028C12.715 9.79412 12.715 10.2057 12.4612 10.4595C12.2073 10.7134 11.7958 10.7134 11.5419 10.4595L8.00156 6.91914L4.46118 10.4595C4.20734 10.7134 3.79578 10.7134 3.54194 10.4595Z'
        fill='white'
      />
    </svg>
  )
}
